import $ from "jquery";

$(() => {
  $(".es-single-tabs-wrap").remove();
  $(".updated").remove();
  $(".byline").remove();
  $(".es-dymanic-content").remove();
  $(".es-top-arrow").remove();

  $(".entry-title").detach().appendTo(".subheading-minor");
  $(".key-features").detach().insertAfter(".es-description");
  // $('.documents-field').detach().insertAfter('.es-map');
  $(".es-cat-price").detach().insertBefore(".es-description");
  $(".documents-field").detach().appendTo(".es-tabbed");
  if (document.querySelector(".location_overwrite")) {
    const locationOverwrite = $(".location_overwrite");
    const locationSection = $(".location1645227120f62102c701f3fb").children(
      ".es-property-single-fields"
    );
    console.log(locationSection);
    locationSection.children("li").detach();
    locationOverwrite.detach().appendTo(locationSection);
  }

  // const address = $('.es-address').text();
  $(".es-address").remove();
  // $('.location1645227120f62102c701f3fb h3').after('<p><em>' + address + '</em></p>');

  let socialDiv = $(".es-single-right")
    .children(".socials")
    .children(".social-buttons")[0];
  // rightDiv.addClass("es-single-right");

  $(".es-share-wrapper").detach().prependTo(socialDiv);
  $(".es-property-fields").remove();
  let documents = $(".documents1645227318f62102d36624ce")
    .children(".es-property-single-fields")
    .children("li");
  documents.each(function () {
    let text = $(this).children("strong").text().slice(0, -2);
    $(this).children("strong").remove();
    $(this).children("a").text(text);
  });

  $(".es-map").children("h3").text("Map");

  const arrows = $(".es-gallery-image-pager-wrap").children(
    ".es-single-gallery-arrow"
  );
  const images = $(".es-gallery-image-pager")
    .children(".slick-list")
    .children(".slick-track")
    .children(".slick-slide");
  if (images.length <= 1) {
    arrows.addClass("hide");
  }

  // if (document.querySelector('.post-password-form')) {
  //   $('.es-info').detach();
  //   $('.es-cat-price').detach();
  //   $('es-description h3').detach();
  //   $('.key-features').detach();
  //   $('.location1645227120f62102c701f3fb').detach();
  //   $('.es-map').detach();
  //   $('.documents-field').detach();
  //   $('.es-single-right').detach();
  // }

  // $('.additional-content').detach().prependTo(rightDiv);

  $("#copyButton").on("click", function (e) {
    const value = window.location.href;
    console.log(value);
    var tempInput = document.createElement("input");
    tempInput.style = "position: absolute; left: -1000px; top: -1000px";
    tempInput.value = value;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    if ($("#copyAlert").hasClass("opacity-0")) {
      $("#copyAlert").removeClass("opacity-0").addClass("opacity-100");
      setTimeout(function () {
        $("#copyAlert").removeClass("opacity-100").addClass("opacity-0");
      }, 3000);
    }
  });
});
